export const LAST_FOUR_STEP = 'lastFour';
export const SUCCESS_STEP = 'success';

export const CARD_ACTIVATION_STEPS = [LAST_FOUR_STEP, SUCCESS_STEP];
